import React from 'react';
import makeCursor from 'legacy-src/utility/Cursor';
import { transformForEditing } from 'legacy/src/components/content/transformations';

import loadEditor from './loadEditor';

class ContentEditor extends React.Component {
  render() {
    const { editorType, ...props } = this.props;
    let cursor;
    if (this._isTransformed) {
      cursor = this.props.cursor;
    } else {
      cursor = makeCursor(
        transformForEditing(this.props.cursor.value),
        [],
        (value) => {
          this._isTransformed = true;
          this.props.cursor.requestChange(value);
        },
      );
    }

    const Editor = loadEditor(editorType || cursor.value.type);

    return (
      <div className="ContentEditor">
        <Editor {...props} cursor={cursor} />
      </div>
    );
  }
}

export default ContentEditor;
